import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class AdminMergeArgs {
  @Field(t => Int)
  fromId!: number

  @Field(t => Int)
  toId!: number

  @Field()
  type!: 'user' | 'pen-name' | 'arc-team'
}
